import { c as _c } from "react/compiler-runtime";
import { IcoCheckSmall16 } from '@onefootprint/icons';
import * as RadixSelect from '@radix-ui/react-select';
import { cx } from 'class-variance-authority';
import { forwardRef, isValidElement } from 'react';
type Size = 'default' | 'compact' | 'tiny';
type ItemProps = RadixSelect.SelectItemProps & {
  size?: Size;
  showChecked?: boolean;
  value: string;
  description?: string;
};
const CustomItem = forwardRef<HTMLDivElement, ItemProps>((t0, ref) => {
  const $ = _c(51);
  let children;
  let description;
  let disabled;
  let props;
  let showChecked;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      children,
      size: t1,
      showChecked,
      value,
      description,
      disabled,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = description;
    $[3] = disabled;
    $[4] = props;
    $[5] = showChecked;
    $[6] = t1;
    $[7] = value;
  } else {
    children = $[1];
    description = $[2];
    disabled = $[3];
    props = $[4];
    showChecked = $[5];
    t1 = $[6];
    value = $[7];
  }
  const size = t1 === undefined ? "default" : t1;
  let T0;
  let T1;
  let hasDescription;
  let isComponent;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[8] !== children || $[9] !== description || $[10] !== disabled || $[11] !== props || $[12] !== ref || $[13] !== size || $[14] !== value) {
    isComponent = isValidElement(children);
    hasDescription = !!description;
    T1 = RadixSelect.Item;
    t7 = value;
    t8 = disabled;
    t9 = true;
    t3 = ref;
    t4 = "no";
    t5 = cx("flex w-full relative cursor-pointer transition-colors duration-50 ease-in-out overflow-hidden rounded-sm gap-2", "text-body-2 text-primary hover:bg-(--dropdown-hover-bg) focus-visible:not:hover:outline focus-visible:not:hover:outline-2 focus-visible:not:hover:outline-accent focus-visible:not:hover:outline-offset-1", "data-[highlighted]:bg-(--dropdown-hover-bg) data-[highlighted]:outline-none data-[disabled]:text-quaternary data-[disabled]:cursor-default data-[disabled]:hover:bg-transparent", {
      "items-center pl-3 pr-4 h-9": size === "default" && !isComponent && !hasDescription,
      "items-center pl-3 pr-4 h-7": (size === "compact" || size === "tiny") && !isComponent && !hasDescription,
      "items-start pl-3 pr-4 py-2.5": isComponent || hasDescription
    });
    t6 = props;
    T0 = RadixSelect.ItemText;
    t2 = cx("flex-1 min-w-0", {
      "text-body-2 overflow-hidden truncate whitespace-nowrap text-ellipsis": !isComponent && !hasDescription,
      "overflow-visible flex flex-col": isComponent || hasDescription
    });
    $[8] = children;
    $[9] = description;
    $[10] = disabled;
    $[11] = props;
    $[12] = ref;
    $[13] = size;
    $[14] = value;
    $[15] = T0;
    $[16] = T1;
    $[17] = hasDescription;
    $[18] = isComponent;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[15];
    T1 = $[16];
    hasDescription = $[17];
    isComponent = $[18];
    t2 = $[19];
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t10;
  if ($[27] !== children || $[28] !== description || $[29] !== hasDescription || $[30] !== isComponent) {
    t10 = isComponent ? children : hasDescription ? <div className="flex flex-col"><span className="text-body-2 font-medium">{children}</span><span className="text-body-2 text-tertiary">{description}</span></div> : <span className="w-full line-clamp-1 text-body-2">{children}</span>;
    $[27] = children;
    $[28] = description;
    $[29] = hasDescription;
    $[30] = isComponent;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== T0 || $[33] !== t10 || $[34] !== t2) {
    t11 = <T0 className={t2}>{t10}</T0>;
    $[32] = T0;
    $[33] = t10;
    $[34] = t2;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== showChecked) {
    t12 = showChecked && <RadixSelect.ItemIndicator className="flex flex-shrink-0 justify-center items-center ml-auto"><IcoCheckSmall16 /></RadixSelect.ItemIndicator>;
    $[36] = showChecked;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t11 || $[39] !== t12 || $[40] !== t3 || $[41] !== t4 || $[42] !== t5 || $[43] !== t6) {
    t13 = <div ref={t3} translate={t4} className={t5} {...t6}>{t11}{t12}</div>;
    $[38] = t11;
    $[39] = t12;
    $[40] = t3;
    $[41] = t4;
    $[42] = t5;
    $[43] = t6;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== T1 || $[46] !== t13 || $[47] !== t7 || $[48] !== t8 || $[49] !== t9) {
    t14 = <T1 value={t7} disabled={t8} asChild={t9}>{t13}</T1>;
    $[45] = T1;
    $[46] = t13;
    $[47] = t7;
    $[48] = t8;
    $[49] = t9;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  return t14;
});
export default CustomItem;